import "../styles/Project.css"

function Project({img}) {
    return (
        <a href="https://qrfood-artemis.vercel.app" target="_blank" rel="noreferrer">
        <div className="project">
            <img src={img} alt="project" />
        </div>
        </a>
    )
}

export default Project
